import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useProfile } from "@/context/ProfileContext";
import { UserAvatar } from "@/components/ui-nw/UserAvatar";
import { FollowButton } from "@/components/profile/FollowButton";

// Creator attribution with the existing follow system.
export const CreatorChip = ({ owner, compact = false }) => {
  const { request, profile: me } = useProfile();
  const [p, setP] = useState(null);
  useEffect(() => { request("get", `/profiles/${owner.username}`).then(setP).catch(() => {}); }, [owner.username, request]);
  const isMe = me?.user_id === owner.user_id;

  return (
    <div data-testid="creator-chip" className="flex items-center gap-3">
      <Link to={`/u/${owner.username}`} className="flex items-center gap-2.5 min-w-0">
        <UserAvatar profile={owner} size={compact ? "h-9 w-9" : "h-11 w-11"} textSize="text-xs" />
        <span className="min-w-0">
          <span className="block truncate font-semibold text-white">{owner.display_name}</span>
          {!compact && <span className="block text-xs text-slate-500">{p ? `${p.stats.followers} follower${p.stats.followers === 1 ? "" : "s"}` : `@${owner.username}`}</span>}
        </span>
      </Link>
      {p && !isMe && <FollowButton profile={p} onChange={({ is_following, followers }) => setP({ ...p, is_following, stats: { ...p.stats, followers } })} />}
    </div>
  );
};
